export default "<div id=\"wrapper_borrower_auth\">\n    <div class=\"borrower-auth-content\">\n        <router-outlet></router-outlet>\n    </div>\n</div>\n\n"